<template>
  <div class="third-party-login-container-wrapper">
    <div class="container-title">{{ containerTitle }}</div>
    <div class="login-form content-form">
      <div class="form-line" :class="message.account.show && message.account.isError && 'has-error'">
        <el-input
          v-model="thirdPartyForm.username"
          name="account"
          class="line-input"
          :placeholder="accountPlaceholder"
          @change="onAccountChange"
          @focus="onAccountFocus"
          @blur="onAccountBlur"
        >
        </el-input>
        <div v-show="message.account.show" class="line-tip">{{ message.account.textI18nKey ? $t(message.account.textI18nKey) : message.account.text }}</div>
      </div>
      <div class="form-line" :class="message.password.show && message.password.isError && 'has-error'">
        <el-input
          v-model="thirdPartyForm.userpwd"
          ref="password"
          name="password"
          class="line-input"
          :type="viewPassword ? 'text' : 'password'"
          :placeholder="$t('login.common.placeholder.password')"
          @change="onPasswordChange"
          @focus="onPasswordFocus"
          @blur="onPasswordBlur"
          @keypress.enter.native="onLoginBtnClick"
        >
          <template #suffix>
            <i class="password-icon iconfont" :class="viewPassword ? 'iconVisible' : 'iconHide1'" @click="onViewPassword"></i>
          </template>
        </el-input>
        <div v-show="message.password.show" class="line-tip">{{ $t(message.password.textI18nKey) }}</div>
      </div>
    </div>
    <div class="button-container">
      <el-button class="back-btn" @click="onBackBtnClick">{{ $t('login.common.btn.back') }}</el-button>
      <el-button class="login-btn" type="primary" @click="onLoginBtnClick" :disabled="!canThirdPartyLogin">{{ $t('login.common.btn.login') }}</el-button>
    </div>
    <div class="form-bottom">
      <div class="bottom-line">
        <div class="forget-password">
          <a class="forget-password-link" :href="forgetPasswordUrl">{{ $t('login.common.btn.forgetPassword') }}</a>
        </div>
      </div>
      <div class="bottom-line">
        <el-checkbox v-model="agree" class="policy-checkbox">
          <span>{{ $t('login.common.message.policy.tip') }}</span>
          <a class="link" href="/tos/" target="_blank">{{ $t('login.common.message.policy.userAgreement') }}</a>
          <span> & </span>
          <a class="link" href="/policy/" target="_blank">{{ $t('login.common.message.policy.privacyPolicy') }}</a>
        </el-checkbox>
        <div class="line-tip"></div>
      </div>
    </div>
    <DialogWrapper
      destroyOnClose
      hideFooter
      :show.sync="importResumeDialog.show"
      :loading="importResumeDialog.loading"
      :close-on-click-modal="false"
      :showClose="false"
      :width="dialogWidth"
    >
      <div class="select-resume-container">
        <div class="select-resume-item">
          <span class="title">{{ $t(`${thirdPartyI18nPrefix}.label.resumeName`) }}</span>
          <el-select class="content" aria-required="true" v-model="importResumeSelectFrom.selectUrl" :placeholder="$t(`${thirdPartyI18nPrefix}.placeholder.resume`)">
            <el-option
              v-for="(item, index) in importResumeList"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="btn-container">
          <el-button class="action-btn cancel-btn" @click="handelSkipImportResume">
            {{ $t(`${thirdPartyI18nPrefix}.btn.skip`) }}
          </el-button>
          <el-button class="action-btn login-btn" type="primary" @click="handelImportResume">
            {{ $t(`${thirdPartyI18nPrefix}.btn.import`) }}
          </el-button>
        </div>
      </div>
    </DialogWrapper>
    <RectLoading v-show="showThirdPartyLoading" class="loading"></RectLoading>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { mixedRouterPush } from '@/router/routes'
import { THIRD_PARTY_CHANNEL_TYPE_51, THIRD_PARTY_CHANNEL_TYPE_JOBSTREET, THIRD_PARTY_LOGIN_STATUS_MAPPING } from '@/constant/thirdParty'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import RectLoading from '@/components/loading/rectLoading.vue'
// import { ACCOUNT_TYPE } from '@/constant/common'
import { deviceType } from '@/utils/common'

export default {
  components: {
    DialogWrapper,
    RectLoading
  },
  props: {
    company: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate',
      thirdPartyI18nPrefix: 'thirdParty',
      thirdPartyForm: {
        thirdparty: THIRD_PARTY_CHANNEL_TYPE_51,
        username: '',
        userpwd: '',
        login_verify: ''
      },
      forgetPasswordUrl: '',
      viewPassword: false,
      canThirdPartyLogin: true,
      showThirdPartyLoading: false,
      agree: true,
      message: {
        account: {
          show: false,
          isError: false,
          textI18nKey: null
        },
        password: {
          show: false,
          isError: false,
          textI18nKey: null
        }
      },
      thirdPartyTask: {
        thirdparty: '',
        taskId: null,
        status: '',
        times: 0
      },
      importResumeSelectFrom: {
        resumeList: [],
        selectUrl: null
      },
      importResumeDialog: {
        show: false,
        loading: false
      }
    }
  },
  computed: {
    containerTitle () {
      if (this.thirdPartyType === THIRD_PARTY_CHANNEL_TYPE_51) {
        return this.$t('login.common.title.51job')
      } else if (this.thirdPartyType === THIRD_PARTY_CHANNEL_TYPE_JOBSTREET) {
        return this.$t('login.common.title.jobStreet')
      }
      return this.$t('login.common.title.login')
    },
    dialogWidth () {
      return deviceType.isPc ? null : '90%'
    },
    thirdPartyType () {
      return this.$route.params.thirdPartyType
    },
    accountPlaceholder () {
      return this.$t('login.common.placeholder.emailOrPhone')
    },
    importResumeList () {
      const list = []
      const resumeFrom = this.importResumeSelectFrom.resumeList || []
      const cnName = this.$t(`${this.thirdPartyI18nPrefix}.label.resumeCnName`)
      const enName = this.$t(`${this.thirdPartyI18nPrefix}.label.resumeEnName`)
      _.forEach(resumeFrom, (item) => {
        if (item.cn_resume_url === item.en_resume_url) {
          list.push({
            name: item.resume_name,
            value: item.cn_resume_url
          })
        } else {
          if (item.cn_resume_url) {
            list.push({
              name: item.resume_name + cnName,
              value: item.cn_resume_url
            })
          }
          if (item.en_resume_url) {
            list.push({
              name: item.resume_name + enName,
              value: item.en_resume_url
            })
          }
        }
      })
      return list
    }
  },
  created () {
    this.thirdPartyForm.thirdparty = this.thirdPartyType
    this.initData()
  },
  methods: {
    ...mapActions('account', ['getLogonAccountNextPage']),
    ...mapActions('personal', ['login', 'getResumeFromThirdParty', 'checkLoginStatusForThirdParty', 'uploadResumeFromThirdparty', 'getForgetPasswordUrlForThirdPartyLogin']),
    async initData () {
      try {
        const resp = await this.getForgetPasswordUrlForThirdPartyLogin({ type: this.thirdPartyType })
        if (resp && resp.url) {
          this.forgetPasswordUrl = resp.url
        }
      } finally {

      }
    },
    onAccountChange () {
      this.validate(this.message.account)
    },
    onAccountFocus () {
      this.clearErrorMessage(this.message.account)
    },
    onAccountBlur () {
      this.validate(this.message.account)
    },
    onPasswordChange () {
      this.validate(this.message.password)
    },
    onPasswordFocus () {
      this.clearErrorMessage(this.message.password)
    },
    onPasswordBlur () {
      this.validate(this.message.password)
    },
    onViewPassword () {
      this.viewPassword = !this.viewPassword
    },
    setErrorMessage (message, textI18nKey, getter) {
      if (!message) {
        delete this.message.account.text
        _.forEach(this.message, msg => this.setErrorMessage(msg, textI18nKey, getter))
        return
      }
      if (getter) {
        Object.defineProperty(message, 'text', {
          configurable: true,
          enumerable: true,
          get: getter
        })
      }
      message.textI18nKey = textI18nKey
      message.isError = true
      message.show = true
    },
    validate (message) {
      if (!message) {
        return _.chain(this.message).map(this.validate).includes(false).value()
      }
      let hasError = false
      let textI18nKey = null
      let getter = null
      if (message === this.message.account) {
        if (!this.thirdPartyForm.username) {
          hasError = true
          getter = () => this.accountPlaceholder
        }
      } else if (message === this.message.password) {
        if (!this.thirdPartyForm.userpwd) {
          hasError = true
          textI18nKey = 'login.common.placeholder.password'
        }
      }
      if (hasError) {
        this.setErrorMessage(message, textI18nKey, getter)
        return false
      } else {
        this.clearErrorMessage(message)
        return true
      }
    },
    onBackBtnClick () {
      const back = this.$route.query.back
      if (back) {
        mixedRouterPush(back)
        return
      }
      this.$router.go(-1)
      // this.$router.push({ path: `/passport/${ACCOUNT_TYPE.CANDIDATE}/login`, query: this.$route.query })
    },
    async onLoginBtnClick () {
      if (!this.agree) {
        this.$message.warning(this.$t('login.common.message.agreePolicyFirst'))
        return
      }
      const hasError = this.validate()
      if (hasError) {
        return
      }
      this.canThirdPartyLogin = false
      this.showThirdPartyLoading = true
      const resp = await this.getResumeFromThirdParty(this.thirdPartyForm)
      if (resp && resp.data) {
        if (resp.status === 'status') {
          this.thirdPartyTask.taskId = resp.data
          this.thirdPartyTask.status = resp.status
          this.thirdPartyTask.thirdparty = this.thirdPartyForm.thirdparty
          this.checkThirdPartyStatus()
        } else if (resp.status === 'failed' && resp.data?.errmsg) {
          if (THIRD_PARTY_LOGIN_STATUS_MAPPING[resp.data.errmsg]) {
            this.$message.error(this.$t(`${this.thirdPartyI18nPrefix}.message.${THIRD_PARTY_LOGIN_STATUS_MAPPING[resp.data.errmsg].i18nKey}`))
          } else {
            this.$message.error(this.$t(`${this.i18nPrefix}.message.thirdPartyLoginError`))
          }
          this.canThirdPartyLogin = true
          this.showThirdPartyLoading = false
        } else {
          this.$message.error(this.$t(`${this.i18nPrefix}.message.thirdPartyLoginError`))
          this.canThirdPartyLogin = true
          this.showThirdPartyLoading = false
        }
      }
    },
    async checkThirdPartyStatus () {
      if (this.thirdPartyTask.thirdparty && this.thirdPartyTask.taskId) {
        this.thirdPartyTask.times++
        const resp = await this.checkLoginStatusForThirdParty({
          tid: this.thirdPartyTask.taskId,
          thirdparty: this.thirdPartyTask.thirdparty
        })
        if (resp && resp.status === 'status') {
          if (this.thirdPartyTask.times > 30) {
            this.cleanThirdPartyStatus()
            this.$message.error(this.$t(`${this.thirdPartyI18nPrefix}.message.loadResumeFailedLater`))
            this.canThirdPartyLogin = true
            this.showThirdPartyLoading = false
            return
          }
          setTimeout(this.checkThirdPartyStatus, 1000)
        } else if (resp.status === 'failed' && resp.data?.errmsg) {
          if (THIRD_PARTY_LOGIN_STATUS_MAPPING[resp.data.errmsg]) {
            this.$message.error(this.$t(`${this.thirdPartyI18nPrefix}.message.${THIRD_PARTY_LOGIN_STATUS_MAPPING[resp.data.errmsg].i18nKey}`))
          } else {
            this.$message.error(this.$t(`${this.thirdPartyI18nPrefix}.message.thirdPartyLoginError`))
          }
          this.canThirdPartyLogin = true
          this.showThirdPartyLoading = false
        } else if (resp.status === 'ok' && resp.data) {
          const resumeList = resp.data
          if (resumeList && resumeList.length > 0) {
            this.importResumeSelectFrom.resumeList = resumeList
            const cnUrl = resumeList[0].cn_resume_url
            const enUrl = resumeList[0].en_resume_url
            this.importResumeSelectFrom.selectUrl = cnUrl || enUrl
          }
          this.importResumeDialog.show = true
          this.canThirdPartyLogin = true
          this.showThirdPartyLoading = false
        }
      }
    },
    async handelImportResume () {
      this.importResume(true)
    },
    handelSkipImportResume () {
      this.importResume()
    },
    cleanThirdPartyStatus () {
      this.importResumeSelectFrom = {
        resumeList: [],
        selectUrl: null
      }
    },
    clearErrorMessage (message) {
      message.show = false
      message.isError = false
      message.textI18nKey = null
    },
    async importResume (skipImport = false) {
      if (!this.importResumeSelectFrom.selectUrl || this.importResumeDialog.loading) {
        return
      }
      this.importResumeDialog.loading = true
      const data = {
        resume_url: skipImport ? this.importResumeSelectFrom.selectUrl : '',
        thirdparty_username: this.thirdPartyForm.username,
        login_username: this.thirdPartyForm.username,
        thirdparty: this.thirdPartyType
      }
      try {
        const resp = await this.uploadResumeFromThirdparty(data)
        if (resp) {
          if (resp.status === 'ok') {
            this.importResumeDialog.show = false
          } else if (resp.status === 'error' || resp.status === 'failed') {
            if (resp.data?.errmsg) {
              this.$message.error(resp.data.errmsg)
            } else {
              this.$message.error(this.$t(`${this.thirdPartyI18nPrefix}.message.praseFailure`))
            }
          }
          this.handelNextPage()
        }
      } finally {
        this.importResumeDialog.loading = false
      }
    },
    async handelNextPage () {
      const back = this.getBackUrl()
      if (back) {
        mixedRouterPush(back)
        return
      }
      const resp = await this.getLogonAccountNextPage({
        back: this.getBackUrl()
      })
      if (resp) {
        mixedRouterPush(resp.next_page)
      }
    },
    getBackUrl () {
      const query = this.$route.query
      return query.back ? `${query.back}${this.$route.hash}` : null
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
.third-party-login-container-wrapper {
  position: relative;

  .container-title {
    padding-top: 38px;
    line-height: 40px;
    color: #303133;
    font-size: 28px;
    font-weight: 500;
  }

  .login-form {
    margin-top: 24px;

    .form-line {
      min-height: 40px;
      margin-bottom: 24px;

      &.has-error {
        margin-bottom: 6px;

        .line-tip {
          padding-left: 0;
          color: #f56c6c;
        }

        .line-input {
          ::v-deep {
            > .el-input__inner {
              border-color: #f56c6c;
            }

            .el-input-group__prepend,
            .el-input-group__append {
              border-color: #f56c6c;
            }
          }
        }
      }

      .line-input {
        ::v-deep {
          .el-input__inner {
            border-radius: 2px;
            padding-left: 14px;
            padding-right: 35px;
          }

          .el-input__suffix {
            right: 14px;
          }
        }

        .arrow-icon {
          height: 40px;
          line-height: 40px;
          cursor: pointer;
        }

        .password-icon {
          height: 40px;
          line-height: 40px;
          cursor: pointer;
          font-size: 14px;
          color: #909399;
        }
      }

      .line-tip {
        padding-left: 15px;
        font-size: 12px;
        line-height: 18px;
      }
    }
  }

  .button-container {
    display: flex;
    justify-content: space-between;

    .el-button {
      width: 47%;
      padding: 9px 0;
      border-radius: 2px;
      line-height: 22px;
      font-size: 16px;
      text-align: center;
      border: 0;
    }

    .back-btn {
      border: 1px solid #E4E7ED;
      color: var(--custom-color, #0096cc);
      background-color: #fff;
    }

    .login-btn {
      background-color: var(--custom-color, #0096cc);
      color: #fff;
    }
  }

  .form-bottom {
    margin-top: 26px;

    .bottom-line {
      margin-bottom: 10px;

      .forget-password {
        text-align: right;

        .forget-password-link {
          display: inline-block;
          color: #606266;
          font-size: 12px;
          text-decoration: underline;

          &:hover {
            color: #717378;
            text-decoration: underline;
          }

          &:visited {
            color: #606266;
            text-decoration: underline;
          }
        }
      }

      .policy-checkbox {
        white-space: nowrap;

        .link {
          color: var(--custom-color, #0096cc);
        }

        ::v-deep {
          .el-checkbox__inner {
            width: 12px;
            height: 12px;

            &::after {
              top: 0;
              left: 3px;
            }
          }

          &.is-focus .el-checkbox__inner {
            border-color: var(--custom-color, #0096cc);
          }

          &.is-checked .el-checkbox__inner {
            background-color: var(--custom-color, #0096cc);
            border-color: var(--custom-color, #0096cc);
          }

          .el-checkbox__label {
            white-space: initial;
            word-break: break-word;
            vertical-align: text-top;
            color: #606266;
            line-height: 19px;
            font-size: 12px;
            font-weight: 400px;
          }
        }
      }
    }
  }

  .select-resume-container {
    .select-resume-item {
      width: 80%;
      margin: auto;
      display: flex;
      align-items: center;
      justify-content: center;

      .title {
        width: 30%;
        margin-right: 30px;
        text-align: right;
        color: #000000;
      }

      .content {
        width: 68%;
      }
    }

    .btn-container {
      width: 80%;
      margin: 50px 10% 0 10%;
      display: flex;
      justify-content: space-between;

      .cancel-btn {
        background-color: #fff;
        color: var(--custom-color, #0096cc);

        &:hover {
          background-color: #fff;
        }
      }

      .login-btn {
        background-color: var(--custom-color, #0096cc);
        color: #fff;
      }
    }
  }

  .loading {
    position: absolute;
  }
}
.is-mobile {
  .third-party-login-container-wrapper {
    .container-title {
      font-size: 30px;
      line-height: 44px;
    }

    .select-resume-container {
      .select-resume-item {
        width: auto;
      }

      .btn-container {
        width: auto;
        margin-left: 0;
        margin-right: 0;
      }
    }
  }
}

.has-company-info {
  .third-party-login-container-wrapper {
    .container-title {
      padding-top: 0;
    }
  }
}
</style>
